import React from 'react';
import LeaveManagement from './LeaveManagement';

const LeaveTypes = () => {
  return <LeaveManagement />;
};

export default LeaveTypes;